import { FC } from 'react';
import { Text, Tooltip } from '@chakra-ui/react';

type Props = {
  text: string;
  textMaxWidth?: string;
  visibleTooltip?: boolean;
  tooltipMaxWidth?: string;
  display?: string;
  noOfLines?: number;
};

export const TextWithTooltip: FC<Props> = ({
  text,
  textMaxWidth = 'auto',
  visibleTooltip = false,
  tooltipMaxWidth = 'auto',
  display = '-webkit-box',
  noOfLines = 1,
}) =>
  !visibleTooltip ? (
    <Text
      color="inherit"
      maxWidth={textMaxWidth}
      noOfLines={noOfLines}
      display={display}
    >
      {text}
    </Text>
  ) : (
    <Tooltip
      label={text}
      bg="gray.50"
      color="black"
      placement="bottom-start"
      whiteSpace="pre-wrap"
      maxWidth={tooltipMaxWidth}
    >
      <Text
        color="inherit"
        maxWidth={textMaxWidth}
        noOfLines={noOfLines}
        display={display}
      >
        {text}
      </Text>
    </Tooltip>
  );
